import {getSideBarLabel} from "../utils/auth"

export const menuItems = [
    {
        id: 0,
        label: getSideBarLabel(),
        isTitle: true
    },
    {
        id: 1,
        label: "Statistika",
        icon: "bx-stats",
        i18n:'Statistic',
        link: "/statistics",
        roles: ['school'],

    },
    {
        id: 2,
        label: "Ish orinlari",
        i18n:"Work_places",
        icon: "bx-folder",
        link: "/jobs",
        roles: ['school'],
    },

    {
        id: 3,
        label: "Arizalar",
        i18n:'Applications',
        icon: "bx-file",
        link: "/applications",
        roles: ['school'],
    },
    {
        id: 4,
        label: "Test Natijalari",
        i18n: 'Test_results',
        icon: "bx-paste",
        link: "/testresults-main",
        roles: ['school'],
    },
    {
        id:5,
        label: "Bosh sahifa",
        i18n:"Home_page",
        link: "/moderator-profile",
        icon: "bx-list-plus",
        roles: ['moderator'],
    },
    {
        id: 6,
        label: "Testlar",
        i18n:"Tests",
        link: "/tests",
        icon: "bx-detail",
        roles: ['moderator'],
    },
    {
        id:7,
        label:'Test Results',
        i18n: "Test_results",
        link:'/test-result',
        icon:"bx-file",
        roles: ['moderator'],
    },
    {
        id:24,
        label:'Foreign Vacancy',
        i18n: "VacancyForeign",
        link:'/fjobs',
        icon:"bx-folder",
        roles: ['moderator'],
    },
    {
        id: 8,
        label: "Test nomzodlar ro'yxati",
        i18n:'Test_candidates',
        link: "/test-candidates",
        icon: "bx-user-check",
        roles: ['moderator'],
    },
    {
        id: 9,
        label: "Ma'lumotnoma",
        i18n:"Reference",
        icon: "bx-info-circle",
        roles: ['moderator'],
        subItems: [
            {
                id: 10,
                label: "Shahar/viloyat",
                i18n:"Region",
                link: "/regions",
                parentId: 1,
                roles: ['moderator'],
            },
            {
                id:11,
                label: "Lavozim darajasi",
                i18n:"Position_level",
                link: "/rank-level",
                parentId: 2,
                roles: ['moderator'],
            },
            {
                id: 12,
                label: 'Lavozimlar',
                i18n:"Positions",
                link: "/ranks",
                parentId: 3,
                roles: ['moderator'],
            },
            {
                id: 13,
                label: 'Fan nomi',
                i18n:"Subject_name",
                link: '/subject-name',
                parentId: 4,
                roles: ['moderator'],
            },
            {
                id: 14,
                label:'Knowledge of Foreign Language Level',
                i18n:'Lang_level',
                link: '/language-level',
                parentId: 5,
                roles: ['moderator'],
            },
            {
                id: 15,
                label: 'Lidership Experience',
                i18n:'Lidership_experience',
                link:'/lidership-experience',
                parentId: 6,
                roles: ['moderator'],
            },
            {
                id: 16,
                label: 'Category',
                i18n:"Category",
                link:'/category',
                parentId: 7,
                icon: 'bx-detail',
                roles: ['moderator'],
            },
            {
                id:17,
                label: 'Experience',
                i18n: "Experience",
                link: '/experience',
                parentId: 8,
                roles: ['moderator'],
            },
            {
                id: 18,
                label: "Tillar",
                i18n:"Languages",
                link:"/tillar",
                parentId: 9,
                icon: 'bx-user-check',
                roles: ['moderator'],
            },
            {
                id:19,
                label: 'Job Types',
                i18n:"Job_Types",
                icon: 'bx-user-check',
                link: '/job-types',
                parentId: 10,
                roles: ['moderator'],
            },
            {
                id: 20,
                label: 'Education',
                i18n:"Education",
                icon: 'bx-paste',
                link: '/education',
                parentId: 11,
                roles: ['moderator'],
            },
            {
                id: 21,
                label: 'Work Places',
                i18n:"Work_places",
                icon: 'bx-stats',
                link: '/work-places',
                parentId: 12,
                roles: ['moderator'],
            },
            {
                id: 22,
                label: 'Payment Type',
                i18n: "PaymentTypes",
                icon:'bx-info-circle',
                link: '/payment-type',
                parentId: 13,
                roles: ['moderator'],
            },
        ],
    },
    {
        id: 23,
        label: "Foydalanuvchilar",
        i18n: "Users",
        link: "/users",
        icon: "bx-user",
        roles: ['moderator'],
    },

]

